import type { ReferentialEnum } from "./referential"

export enum SourceName {
  PHARMUPP = "PHARMUPP",
  DIGIPHARMACIE = "DIGIPHARMACIE",
  SANTE_STAT = "SANTE_STAT",
  GERS = "GERS",
  SANTESTAT = "SANTESTAT",
  CERP = "CERP",
  SAGITTA = "SAGITTA",
}

export const sourceEnum = {
  [SourceName.PHARMUPP]: { label: "PharmUPP" },
  [SourceName.DIGIPHARMACIE]: { label: "Digipharmacie" },
  [SourceName.SANTE_STAT]: { label: "SantéStat" },
  [SourceName.GERS]: { label: "SantéStat" },
  [SourceName.SANTESTAT]: { label: "SantéStat" },
  [SourceName.CERP]: { label: "CERP" },
  [SourceName.SAGITTA]: { label: "SAGITTA" },
} as const satisfies ReferentialEnum
